import styled from 'styled-components';

export const HeaderRoot = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
`;
